import React, {Component} from 'react';
import {Modal, Table, Button} from 'react-bootstrap';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import Inputmask from 'inputmask';
import moment from 'moment';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import RaisedButton from 'material-ui/RaisedButton';
import {bin} from 'react-icons-kit/icomoon/bin';
import SvgIcon from 'react-icons-kit';
import $ from 'jquery';

var Config = require('../../../config');
var session = sessionStorage.getItem('health_facilities_name');

class TransfutionalForm extends Component{
	constructor(props){
		super(props);

		this.onSave = this.onSave.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.checkIncident = this.checkIncident.bind(this);
		this.regresar = this.regresar.bind(this);

		this.state = {
			unit_id:"",

			start_type:"START",
			end_type:"END",
			during_type:'DURING',

			start_id:"",
			start_date:"",
			start_hour:"",
			start_medical_name:"",
			start_sistiolica:"",
			start_diastiolica:"",
			start_pulse:"",
			start_temperature:"",
			start_timestamp:"",
			start_incidents:[],
			start_heart_rate:"",

			during_id:"",
			during_date:"",
			during_hour:"",
			during_medical_name:"",
			during_sistiolica:"",
			during_diastiolica:"",
			during_pulse:"",
			during_temperature:"",
			during_timestamp:"",
			during_incidents:[],
			during_heart_rate:"",

			end_id:"",
			end_date:"",
			end_hour:"",
			end_medical_name:"",
			end_sistiolica:"",
			end_diastiolica:"",
			end_pulse:"",
			end_temperature:"",
			end_timestamp:"",
			end_incidents:[],
			end_heart_rate:"",

			valid_start:false,
			valid_end:false,
			valid_during:false,

			observations:"",
			incidents:[],
			incidents_list:[],
			list_incidents:[],
			incident_id:"",
			incident_type_id:"",
			method_incidents:'post',
			transfusional_id:"",
			incidents_type:[],
			check_incident:"NO",
			incident_time:"",
			method:"",
			verify_staff:"NO",
			returned_empty_container:"NO",
			returned_printed_document:"NO",
			has_transfusion_incident:"NO"
		}
	}

	componentDidMount(){
		$(document).on('blur', '#start_date', (e)=>{
			if(e.target.validationMessage !== ""){
				swal('Error', e.target.validationMessage, 'error');
				
				setTimeout(()=>{
					$('#'+e.target.id).val('')
						.attr('type', 'text')
						.attr('type', 'date');
				}, 4000);

				$('#'+e.target.id).addClass('error');
			}else{
				$('#'+e.target.id).removeClass('error');
			}
		});

		$(document).on('blur', '#during_date', (e)=>{
			if(e.target.validationMessage !== ""){
				swal('Error', e.target.validationMessage, 'error');
				
				setTimeout(()=>{
					$('#'+e.target.id).val('')
						.attr('type', 'text')
						.attr('type', 'date');
				}, 4000);

				$('#'+e.target.id).addClass('error');
			}else{
				$('#'+e.target.id).removeClass('error');
			}
		});

		$(document).on('blur', '#end_date', (e)=>{
			if(e.target.validationMessage !== ""){
				swal('Error', e.target.validationMessage, 'error');
				
				setTimeout(()=>{
					$('#'+e.target.id).val('')
						.attr('type', 'text')
						.attr('type', 'date');
				}, 4000);
				
				$('#'+e.target.id).addClass('error');
			}else{
				$('#'+e.target.id).removeClass('error');
			}
		});


		var selector_start = document.getElementById("start_hour");
		var im_start = new Inputmask("--:--");
		im_start.mask(selector_start);

		var selector_during = document.getElementById("during_hour");
		var im_during = new Inputmask("--:--");
		im_during.mask(selector_during)

		var selector_finish = document.getElementById("end_hour");
		var im_finish = new Inputmask("--:--");
		im_finish.mask(selector_finish)

		fetch(Config.default.apiGateway.URL+'lookups_level2?type=transfusion_incident&option=parents',{
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					incidents_type:response
				});				
			}
		})

		fetch(Config.default.apiGateway.URL+'lookups_level2?type=transfusion_incident&option=children',{
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					list_incidents:response
				});				

				this.getValues();
			}
		})		
	}

	getValues(){
		var id = this.props.match.params.id;
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'transfusional_control/?unit_id='+id, {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					unit_id:id,
				});
				if(response.transfusional.length > 0){
					this.setState({method:'put'});

					var incident = 0;
					response.transfusional.map((t)=>{

						if(t.control.type === 'START'){
							this.setState({
								start_id:t.control.id,
								start_date:moment(t.control.date).format('YYYY-MM-DD'),
								start_hour:t.control.hour !== null ? moment(t.control.hour, 'H:mm:ss').format('HH:mm') :  "",
								start_medical_name:t.control.medical_name,
								start_sistiolica:t.control.sistiolica,
								start_diastiolica:t.control.diastiolica,
								start_pulse:t.control.pulse,
								start_temperature:t.control.temperature,
								start_timestamp:t.control.timestamp,
								start_incidents: t.incidents,
								start_heart_rate: t.control.heart_rate,
								verify_staff: t.control.double_check ? 'SI' : 'NO',
								returned_empty_container: t.control.returned_empty_container ? 'SI' : 'NO',
								returned_printed_document: t.control.returned_printed_document ? 'SI' : 'NO',
								has_transfusion_incident: t.control.has_transfusion_incident ? 'SI' : 'NO'
							})

							if(t.incidents.length > 0){
								incident++;
							}
						}

						if(t.control.type === 'DURING'){
							this.setState({
								during_id:t.control.id,
								during_date:moment(t.control.date).format('YYYY-MM-DD'),
								during_hour:t.control.hour !== null ? moment(t.control.hour, 'H:mm:ss').format('HH:mm') :  "",
								during_medical_name:t.control.medical_name,
								during_sistiolica:t.control.sistiolica,
								during_diastiolica:t.control.diastiolica,
								during_pulse:t.control.pulse,
								during_temperature:t.control.temperature,
								during_timestamp:t.control.timestamp,
								during_incidents: t.incidents,
								during_heart_rate: t.control.heart_rate,
								verify_staff: t.control.double_check ? 'SI' : 'NO',
								returned_empty_container: t.control.returned_empty_container ? 'SI' : 'NO',
								returned_printed_document: t.control.returned_printed_document ? 'SI' : 'NO',
								has_transfusion_incident: t.control.has_transfusion_incident ? 'SI' : 'NO'
							})
							if(t.incidents.length > 0){
								incident++;
							}
						}

						if(t.control.type === 'END'){
							this.setState({
								end_id:t.control.id,
								end_date:moment(t.control.date).format('YYYY-MM-DD'),
								end_hour:t.control.hour !== null ? moment(t.control.hour, 'H:mm:ss').format('HH:mm') :  "",
								end_medical_name:t.control.medical_name,
								end_sistiolica:t.control.sistiolica,
								end_diastiolica:t.control.diastiolica,
								end_pulse:t.control.pulse,
								end_temperature:t.control.temperature,
								end_timestamp:t.control.timestamp,
								end_incidents: t.incidents,
								end_heart_rate: t.control.heart_rate,
								verify_staff: t.control.double_check ? 'SI' : 'NO',
								returned_empty_container: t.control.returned_empty_container ? 'SI' : 'NO',
								returned_printed_document: t.control.returned_printed_document ? 'SI' : 'NO',
								has_transfusion_incident: t.control.has_transfusion_incident ? 'SI' : 'NO'
							})
						}

					})

					if(incident !== 0){
						this.setState({check_incident:"SI", incident_time:'START'});
						this.loadIncidents(this.state.start_incidents);
					}

				}else{
					this.setState({method:'post'});
					
				}
			}
		})
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value
		});

		if(e.target.value !== ""){
			this.showInputError(e.target.name);
		}

		if(e.target.name === 'observations'){
			if(this.state.incident_time === 'START'){
				if(this.state.start_incidents.length > 0){
					this.state.start_incidents[0].incident.observations = e.target.value;
				}else{
					this.setState({
						start_incidents: [{incident:{observations:e.target.value}, detail:[]}]
					})
				}
				
			}

			if(this.state.incident_time === 'DURING'){
				if(this.state.during_incidents.length > 0){
					this.state.during_incidents[0].incident.observations = e.target.value;
				}else{
					this.setState({
						during_incidents: [{incident:{observations:e.target.value}, detail:[]}]
					})
				}
			}

			if(this.state.incident_time === 'END'){
				if(this.state.end_incidents.length > 0){
					this.state.end_incidents[0].incident.observations = e.target.value;
				}else{
					this.setState({
						end_incidents: [{incident:{observations:e.target.value}, detail:[]}]
					})
				}
			}
		}

		if(e.target.name === 'start_hour' || e.target.name === 'during_hour' || e.target.name === 'end_hour'){
			var hour = moment(e.target.value, 'h:mm a');

			if(hour.format('H:mm') === "Invalid date" || e.target.value.indexOf('-') !== -1){
				document.getElementById(e.target.id).classList.add("error");
				document.getElementById(e.target.name).style.borderColor = "red";
			}else{
				document.getElementById(e.target.name).style.borderColor = "#ccc";
				document.getElementById(e.target.id).classList.remove("error");
			}
		
		}

		if(e.target.name === 'incident_time'){
			if(e.target.value === 'START'){
				this.loadIncidents(this.state.start_incidents);
			}

			if(e.target.value === 'DURING'){
				this.loadIncidents(this.state.during_incidents);
			}

			if(e.target.value === 'END'){
				this.loadIncidents(this.state.end_incidents);
			}
			
		}
	}

	isValidForm() {
		const select = document.querySelector('div.modal-body');
  		const inputs = select.querySelectorAll('input');
	    //const inputs = document.querySelectorAll('input');
	    let isFormValid = true;
	    inputs.forEach(input => {
	    	if(input.required){
		      	const isInputValid = this.showInputError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });	  
	    
	    return isFormValid;
	}

	showInputError(refName) {
		const control = document.getElementById(refName);
		
		if(control.value === ""){
			if(control !== null){
	            control.classList.add('error');
	        }
			return false;
		}else{
			if(control.className.includes('error')){
				control.classList.remove('error');
			}
			return true;
		}
	}

	onSave(e){
		var error = '';

		if(this.state.check_incident === "SI"){
			if(this.state.incident_time === ""){
				error = 'Campos incompletos';
				document.getElementById('incident_time').classList.add('error');
			}else{
				document.getElementById('incident_time').classList.remove('error');
			}
		}

		if(error === ''){
			this.saveType();
			var obj = [];
			var inc = {};
			setTimeout(()=>{
				if(this.state.valid_start){
					var start = {
						date: moment(this.state.start_date).format('YYYY-MM-DD') !== 'Invalid date' ?
							  	moment(this.state.start_date).format('YYYY-MM-DD') : "",
						hour: moment(this.state.start_hour, 'HH:mm').format('H:mm') !== 'Invalid date' ?
							 	moment(this.state.start_hour, 'HH:mm').format('H:mm') : "",
						medical_name: this.state.start_medical_name,
						sistiolica: this.state.start_sistiolica,
						diastiolica: this.state.start_diastiolica,
						pulse: this.state.start_pulse,
						temperature: this.state.start_temperature,
						unit_id:this.state.unit_id,
						type:this.state.start_type,
						heart_rate:this.state.start_heart_rate,
						double_check: this.state.verify_staff === 'SI' ? true : false,
						returned_empty_container: this.state.returned_empty_container === 'SI' ? true : false,
						returned_printed_document: this.state.returned_printed_document === 'SI' ? true : false,
						has_transfusion_incident: this.state.has_transfusion_incident === 'SI' ? true : false
					}

					if(this.state.start_id !== ""){
						start.id = this.state.start_id;
						start.timestamp = this.state.start_timestamp;
					}

					if(this.state.check_incident === "SI"){
						inc = {};
						if(this.state.method === 'put'){
							inc.transfusional_control_id = start.id;
						}
						
						inc.transfusional_incident_details = [];

						if(this.state.start_incidents.length > 0){
							if(this.state.start_incidents[0].incident.id !== undefined){
								inc.id = this.state.start_incidents[0].incident.id;
							}

							this.state.start_incidents[0].detail.map((d)=>{
								var det = {};

								if(this.state.method === 'put'){
									det.transfusional_control_id = start.id;
								}

								if(d.id !== undefined){
									det.id = d.id;
								}

								det.incident_id = d.incident_id;

								inc.transfusional_incident_details.push(det);
							})
						}

						inc.observations = this.state.start_incidents.length > 0  ? 
											this.state.start_incidents[0].incident.observations
										: '';
						
						start.transfusional_incidents = [inc];
					}

					obj.push(start);
				}

				if(this.state.valid_during){
					var during = {
						date: moment(this.state.during_date).format('YYYY-MM-DD') !== 'Invalid date' ?
							  	moment(this.state.during_date).format('YYYY-MM-DD') : "",
						hour: moment(this.state.during_hour, 'HH:mm').format('H:mm') !== 'Invalid date' ?
							 	moment(this.state.during_hour, 'HH:mm').format('H:mm') : "",
						medical_name: this.state.during_medical_name,
						sistiolica: this.state.during_sistiolica,
						diastiolica: this.state.during_diastiolica,
						pulse: this.state.during_pulse,
						temperature: this.state.during_temperature,
						unit_id:this.state.unit_id,
						type:this.state.during_type,
						heart_rate:this.state.during_heart_rate,
						double_check: this.state.verify_staff === 'SI' ? true : false,
						returned_empty_container: this.state.returned_empty_container === 'SI' ? true : false,
						returned_printed_document: this.state.returned_printed_document === 'SI' ? true : false,
						has_transfusion_incident: this.state.has_transfusion_incident === 'SI' ? true : false
					}
					if(this.state.during_id !== ""){
						during.id = this.state.during_id;
						during.timestamp = this.state.during_timestamp;
					}

					if(this.state.check_incident === "SI"){
						inc = {};
						if(this.state.method === 'put'){
							inc.transfusional_control_id = during.id;
						}

						inc.transfusional_incident_details = [];

						if(this.state.during_incidents.length > 0){
							if(this.state.during_incidents[0].incident.id){
								inc.id = this.state.during_incidents[0].incident.id;
							}
							
							this.state.during_incidents[0].detail.map((d)=>{
								var det = {};

								if(this.state.method === 'put'){
									det.transfusional_control_id = during.id;
								}

								if(d.id !== undefined){
									det.id = d.id;
								}

								det.incident_id = d.incident_id;

								inc.transfusional_incident_details.push(det);
							})
						}

						inc.observations = this.state.during_incidents.length > 0 ?
											 this.state.during_incidents[0].incident.observations
										: '';
						
						during.transfusional_incidents = [inc];
					}


					obj.push(during);
				}

				if(this.state.valid_end){
					var end = {
						date: moment(this.state.end_date).format('YYYY-MM-DD') !== 'Invalid date' ?
							  	moment(this.state.end_date).format('YYYY-MM-DD') : "",
						hour: moment(this.state.end_hour, 'HH:mm').format('H:mm') !== 'Invalid date' ?
							 	moment(this.state.end_hour, 'HH:mm').format('H:mm') : "",
						medical_name: this.state.end_medical_name,
						sistiolica: this.state.end_sistiolica,
						diastiolica: this.state.end_diastiolica,
						pulse: this.state.end_pulse,
						temperature: this.state.end_temperature,
						unit_id:this.state.unit_id,
						type:this.state.end_type,
						heart_rate:this.state.end_heart_rate,
						double_check: this.state.verify_staff === 'SI' ? true : false,
						returned_empty_container: this.state.returned_empty_container === 'SI' ? true : false,
						returned_printed_document: this.state.returned_printed_document === 'SI' ? true : false,
						has_transfusion_incident: this.state.has_transfusion_incident === 'SI' ? true : false
					}
					if(this.state.end_id !== ""){
						end.id = this.state.end_id;
						end.timestamp = this.state.end_timestamp;
					}

					if(this.state.check_incident === "SI"){
						inc = {};
						if(this.state.method === 'put'){
							inc.transfusional_control_id = end.id;
						}
						
						inc.transfusional_incident_details = [];

						if(this.state.end_incidents.length > 0){
							if(this.state.end_incidents[0].incident.id !== undefined){
								inc.id = this.state.end_incidents[0].incident.id;
							}
							
							this.state.end_incidents[0].detail.map((d)=>{
								var det = {};

								if(this.state.method === 'put'){
									det.transfusional_control_id = end.id;
								}

								if(d.id !== undefined){
									det.id = d.id;
								}

								det.incident_id = d.incident_id;

								inc.transfusional_incident_details.push(det);
							})
						}

						inc.observations = this.state.end_incidents.length > 0 ?
											this.state.end_incidents[0].incident.observations
										: '';
						
						end.transfusional_incidents = [inc];
					}


					obj.push(end);
				}

				if(obj.length > 0){
					
					fetch(Config.default.apiGateway.URL+'transfusional_control',{
						method:this.state.method,
						body:JSON.stringify(obj),
						headers: new Headers({
							'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
							'Accept'		: 'application/json',
							'Content-Type'	: 'application/json'
						})
					}).then(res => {
						this.props.waiting.handleClose();
						if(res.ok){
							return 'ok';
						}else{
							res.text().then((msg)=>{
								swal('Error', msg, 'error');
							});
						}
					}).then(response => {
						if(response !== undefined){
							//this.handleClose();
							this.props.history.push('/hemovigilance');
							swal('Correcto', 'Registro guardado correctamente', 'success');		
						}
					})
					
				}else{
					swal('Error', 'Campos Incompletos', 'error');
				}			
					
			}, 500);
		}else{
			swal('Error', error, 'error');
		}
			
	}

	saveType(){
		const select_start = document.querySelector('fieldset.start');
		const start = select_start.querySelectorAll('input');

		var valid_start = 0;
		start.forEach(function(s){
			if(s.value !== ""){
				valid_start++;
			}
			
		})	

		const select_during = document.querySelector('fieldset.during');
		const during = select_during.querySelectorAll('input');

		var valid_during = 0;
		during.forEach(function(s){
			if(s.value !== ""){
				valid_during++;
			}
			
		})		

		const select_end = document.querySelector('fieldset.end');
		const end = select_end.querySelectorAll('input');

		var valid_end = 0;
		end.forEach(function(s){
			if(s.value !== ""){
				valid_end++;
			}
			
		})
		if(valid_start > 0 || this.state.incident_time === 'START'){
			this.setState({valid_start:true});
		}
		if(valid_during> 0 || this.state.incident_time === 'DURING'){
			this.setState({valid_during:true});
		}
		if(valid_end > 0 || this.state.incident_time === 'END'){
			this.setState({valid_end:true});
		}
	}

	checkIncident(e){
		var id_parent = parseInt(e.target.id.split('_')[1]);
		var id_child = parseInt(e.target.id.split('_')[2]);
		var check = e.target.checked;

		var detail = [], incident = {}

		this.state.incidents_type.map((inc, i)=>{
			if(id_parent === inc.id){
				this.state.list_incidents.map((list, j)=>{
					if(id_parent === list.parent.id){
						if(inc.key !== 'CLINICAL_MANIFESTATIONS' && inc.key !== 'INCIDENTS' &&
							inc.key !== 'TYPES_ERROR'){
							if(id_child !== list.lookup.id){
								document.getElementById('check_'+inc.id+'_'+list.lookup.id).checked = false
							}
						}
							
					}
				})
			}
		})

		this.state.incidents_type.map((inc, i)=>{
			this.state.list_incidents.map((list, j)=>{
				if(document.getElementById('check_'+inc.id+'_'+list.lookup.id) !== null){
					if(document.getElementById('check_'+inc.id+'_'+list.lookup.id).checked){
						detail.push({incident_id:list.lookup.id});
					}
				}
			})
		})

		if(this.state.incident_time === 'START'){
			incident.observations = this.state.start_incidents.length > 0 ? this.state.start_incidents[0].incident.observations : this.state.observations;
		
			console.log(this.state.start_incidents)
			if(this.state.start_incidents.length > 0){
				incident.id = this.state.start_incidents[0].incident.id;

				this.state.start_incidents[0].detail.map((d)=>{
					var i_s = detail.findIndex(obj => 
						obj.incident_id === d.incident_id
					)

					if(i_s !== -1){
						detail[i_s].id = d.id;
					}
				});
			
			}

				

			this.setState({start_incidents: [{incident:incident, detail:detail}]});
		}

		if(this.state.incident_time === 'DURING'){
			incident.observations = this.state.during_incidents.length > 0 ? this.state.during_incidents[0].incident.observations : this.state.observations;
			
			if(this.state.during_incidents.length > 0){
				incident.id = this.state.during_incidents[0].incident.id;

				console.log(this.state.during_incidents)
				this.state.during_incidents[0].detail.map((d)=>{
					var i_s = detail.findIndex(obj => 
						obj.incident_id === d.incident_id
					)

					if(i_s !== -1){
						detail[i_s].id = d.id;
					}
				});
			}

				
			this.setState({during_incidents: [{incident:incident, detail:detail}]});
		}

		if(this.state.incident_time === 'END'){
			incident.observations = this.state.end_incidents.length > 0 ? this.state.end_incidents[0].incident.observations : this.state.observations;
			
			if(this.state.end_incidents.length > 0){
				incident.id = this.state.end_incidents[0].incident.id;

				this.state.end_incidents[0].detail.map((d)=>{
					var i_s = detail.findIndex(obj => 
						obj.incident_id === d.incident_id
					)

					if(i_s !== -1){
						detail[i_s].id = d.id;
					}
				});
			}

			
			this.setState({end_incidents: [{incident:incident, detail:detail}]});
		}
	}

	loadIncidents(item){
		this.state.incidents_type.map((inc, i)=>{
			this.state.list_incidents.map((list, j)=>{
				if(document.getElementById('check_'+inc.id+'_'+list.lookup.id) !== null){
					document.getElementById('check_'+inc.id+'_'+list.lookup.id).checked = false
				}			
			})
			
		})
		this.setState({
			observations: item !== undefined && item.length > 0 ? item[0].incident.observations : "",
		});
		item.map((l, i)=>{
			l.detail.map((d, j)=>{
				this.state.incidents_type.map((inc, i)=>{
					this.state.list_incidents.map((list, j)=>{
						if(d.incident_id === list.lookup.id){
							if(document.getElementById('check_'+inc.id+'_'+list.lookup.id) !== null){
								document.getElementById('check_'+inc.id+'_'+list.lookup.id).checked = true
							}
						}				
					})
					
				})
			})
				
		})
	}

	regresar(){
		//this.props.history.push('/hemovigilance');
		this.props.history.goBack();
	}

	render(){
		const {t} = this.props;
		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{session} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.donors.MAIN')} ->
						Registro Hemovigilancia
					</h5>
				</div>

				<div className="col-xs-12">
					<fieldset className="col-xs-12 col-sm-4 start">
						<legend className="color-font">Inicio Transfusión</legend>
						
							<div className="col-xs-12 col-sm-6">
								<span className="span-min">Fecha</span>
								<input type="date" className="form-control hour-input" value={this.state.start_date} 
									name="start_date" id="start_date" onChange={this.handleChange} />
							</div>
							<div className="col-xs-12 col-sm-6">
								<span className="span-min">Hora</span>
								<input id="start_hour" name="start_hour" type="text" data-inputmask-alias="datetime" 
									data-inputmask-inputformat="HH:MM"  onChange={this.handleChange}
									data-inputmask-placeholder="-" value={this.state.start_hour || ""} 
									className="form-control"/>
							</div>

							<div className="col-xs-12">
								<span className="span-min">Iniciada por:</span>
								<input type="text" className="form-control" value={this.state.start_medical_name} 
									name="start_medical_name" id="start_medical_name" onChange={this.handleChange} />
							</div>
							<div className="col-xs-6">
								<span className="span-min">Sistiólica:</span>
								<input type="text" className="form-control" value={this.state.start_sistiolica} 
									name="start_sistiolica" id="start_sistiolica" onChange={this.handleChange} />
							</div>
							<div className="col-xs-6">
								<span className="span-min">Diastiólica:</span>
								<input type="text" className="form-control" value={this.state.start_diastiolica} 
									name="start_diastiolica" id="start_diastiolica" onChange={this.handleChange} />
							</div>
							<div className="col-xs-6">
								<span className="span-min">Pulso:</span>
								<input type="text" className="form-control" value={this.state.start_pulse} 
									name="start_pulse" id="start_pulse" onChange={this.handleChange} />
							</div>
							<div className="col-xs-6">
								<span className="span-min">Temperatura:</span>
								<input type="text" className="form-control" value={this.state.start_temperature} 
									name="start_temperature" id="start_temperature" onChange={this.handleChange} />
							</div>
							<div className="col-xs-6">
								<span className="span-min">Frecuencia Respiratoria:</span>
								<input type="text" className="form-control" value={this.state.start_heart_rate} 
									name="start_heart_rate" id="start_heart_rate" onChange={this.handleChange} />
							</div>
					</fieldset>

					<fieldset className="col-xs-12 col-sm-4 during">
						<legend className="color-font">Durante Transfusión</legend>
							<div className="col-xs-12 col-sm-6">
								<span className="span-min">Fecha</span>
								<input type="date" className="form-control hour-input" value={this.state.during_date} 
									name="during_date" id="during_date" onChange={this.handleChange} />
							</div>
							<div className="col-xs-12 col-sm-6">
								<span className="span-min">Hora</span>
								<input id="during_hour" name="during_hour" type="text" data-inputmask-alias="datetime" 
									data-inputmask-inputformat="HH:MM"  onChange={this.handleChange}
									data-inputmask-placeholder="-" value={this.state.during_hour || ""} 
									className="form-control"/>
							</div>
							<div className="col-xs-12">
								<span className="span-min">Iniciada por:</span>
								<input type="text" className="form-control" value={this.state.during_medical_name} 
									name="during_medical_name" id="during_medical_name" onChange={this.handleChange} />
							</div>
							<div className="col-xs-6">
								<span className="span-min">Sistiólica:</span>
								<input type="text" className="form-control" value={this.state.during_sistiolica} 
									name="during_sistiolica" id="during_sistiolica" onChange={this.handleChange} />
							</div>
							<div className="col-xs-6">
								<span className="span-min">Diastiólica:</span>
								<input type="text" className="form-control" value={this.state.during_diastiolica} 
									name="during_diastiolica" id="during_diastiolica" onChange={this.handleChange} />
							</div>
							<div className="col-xs-6">
								<span className="span-min">Pulso:</span>
								<input type="text" className="form-control" value={this.state.during_pulse} 
									name="during_pulse" id="during_pulse" onChange={this.handleChange} />
							</div>
							<div className="col-xs-6">
								<span className="span-min">Temperatura:</span>
								<input type="text" className="form-control" value={this.state.during_temperature} 
									name="during_temperature" id="during_temperature" onChange={this.handleChange} />
							</div>
							<div className="col-xs-6">
								<span className="span-min">Frecuencia Respiratoria:</span>
								<input type="text" className="form-control" value={this.state.during_heart_rate} 
									name="during_heart_rate" id="during_heart_rate" onChange={this.handleChange} />
							</div>
					</fieldset>

					<fieldset className="col-xs-12 col-sm-4 end form-group">
						<legend className="color-font">Final Transfusión</legend>
							<div className="col-xs-12 col-sm-6">
								<span className="span-min">Fecha</span>
								<input type="date" className="form-control hour-input" value={this.state.end_date} 
									name="end_date" id="end_date" onChange={this.handleChange} />
							</div>
							<div className="col-xs-12 col-sm-6">
								<span className="span-min">Hora</span>
								<input id="end_hour" name="end_hour" type="text" data-inputmask-alias="datetime" 
									data-inputmask-inputformat="HH:MM"  onChange={this.handleChange}
									data-inputmask-placeholder="-" value={this.state.end_hour || ""} 
									className="form-control"/>
							</div>
							<div className="col-xs-12">
								<span className="span-min">Iniciada por:</span>
								<input type="text" className="form-control" value={this.state.end_medical_name} 
									name="end_medical_name" id="end_medical_name" onChange={this.handleChange} />
							</div>
							<div className="col-xs-6">
								<span className="span-min">Sistiólica:</span>
								<input type="text" className="form-control" value={this.state.end_sistiolica} 
									name="end_sistiolica" id="end_sistiolica" onChange={this.handleChange} />
							</div>
							<div className="col-xs-6">
								<span className="span-min">Diastiólica:</span>
								<input type="text" className="form-control" value={this.state.end_diastiolica} 
									name="end_diastiolica" id="end_diastiolica" onChange={this.handleChange} />
							</div>
							<div className="col-xs-6">
								<span className="span-min">Pulso:</span>
								<input type="text" className="form-control" value={this.state.end_pulse} 
									name="end_pulse" id="end_pulse" onChange={this.handleChange} />
							</div>
							<div className="col-xs-6">
								<span className="span-min">Temperatura:</span>
								<input type="text" className="form-control" value={this.state.end_temperature} 
									name="end_temperature" id="end_temperature" onChange={this.handleChange} />
							</div>
							<div className="col-xs-6">
								<span className="span-min">Frecuencia Respiratoria:</span>
								<input type="text" className="form-control" value={this.state.end_heart_rate} 
									name="end_heart_rate" id="end_heart_rate" onChange={this.handleChange} />
							</div>
					</fieldset>

					<div className="col-xs-12 form-group">			
						<div className="col-xs-12 col-sm-2">
							<span className="span-min" style={{fontSize:12}}>¿Hay firma de doble verificación de otro Médico?</span>	
							<select name="verify_staff" id="verify_staff" value={this.state.verify_staff}
								onChange={this.handleChange} className="form-control">
								<option value="NO">NO</option>
								<option value="SI">SI</option>
							</select>
						</div>			
						<div className="col-xs-12 col-sm-2">
							<span className="span-min" style={{fontSize:12}}>¿Han devuelto el envace vacio?</span>
							<select name="returned_empty_container" id="returned_empty_container" value={this.state.returned_empty_container}
								onChange={this.handleChange} className="form-control">
								<option value="NO">NO</option>
								<option value="SI">SI</option>
							</select>
						</div>
						<div className="col-xs-12 col-sm-2">							
							<span className="span-min" style={{fontSize:12}}>¿Han devuelto el impreso control transfusional?</span>
							<select name="returned_printed_document" id="returned_printed_document" value={this.state.returned_printed_document}
								onChange={this.handleChange} className="form-control">
								<option value="NO">NO</option>
								<option value="SI">SI</option>
							</select>
						</div>
						<div className="col-xs-12 col-sm-2">							
							<span className="span-min" style={{fontSize:12}}>¿Marcaron incidente transfucional?</span>
							<select name="has_transfusion_incident" id="has_transfusion_incident" value={this.state.has_transfusion_incident}
								onChange={this.handleChange} className="form-control">
								<option value="NO">NO</option>
								<option value="SI">SI</option>
							</select>
						</div>
					</div>
					<div className="col-xs-12 form-group">
						<div className="col-xs-12 col-sm-2" style={{paddingRight:10}}>
							
							<span>Incidentes</span>
							<select name="check_incident" id="check_incident" value={this.state.check_incident}
								onChange={this.handleChange} className="form-control">
								<option value="NO">NO</option>
								<option value="SI">SI</option>
							</select>
						</div>
					</div>
					<div className="col-xs-12 form-group">
						{this.state.check_incident === "SI" ?
							<div className="col-xs-12 col-sm-2">
								<select className="form-control" name="incident_time" id="incident_time" value={this.state.incident_time}
									onChange={this.handleChange} >
									<option value="">Seleccione...</option>
									<option value="START">Inicio de Transfusión</option>
									<option value="DURING">Durante Transfusión</option>
									<option value="END">Despues de Transfusión</option>
								</select>
							</div>
						:null}
					</div>



					{this.state.check_incident === "SI" ?
						<div>
							<div className="col-xs-12 form-group">
								<div className="col-xs-12">
									<span className="span-min">Observaciones</span>
									<textarea className="form-control" name="observations" id="observations" 
										style={{height:"50px",width:"100%",resize:"none"}}
			        					value={this.state.observations} onChange={this.handleChange} />
								</div>
							</div>
							<div className="col-xs-12">
								{this.state.incidents_type.map((inc, i)=>(
									<fieldset className="col-xs-12 col-sm-3" key={i}>
										<legend>{inc.value_name}</legend>
										{this.state.list_incidents.map((list, j)=>(
											inc.id === list.parent.id ?
												<div className="col-xs-12" key={j}>
													<input type="checkbox" id={'check_'+inc.id+'_'+list.lookup.id}
														onChange={this.checkIncident} style={{marginRight:'10px'}} /> 
													{list.lookup.value_name}
												</div>
											:null
												
										))}
									</fieldset>
								))}
							</div>
						</div>
					:null}

				</div>
				<div className="col-xs-12">
					<div className="col-xs-12" style={{textAlign:'center'}}>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} 
		        			onClick={this.onSave}  style={{margin:12}}/>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} 
		        			onClick={this.regresar} style={{margin:12}}/>
		        	</div>
				</div>
				
			</div>
		)
			
	}
}

export default translate('translations') (TransfutionalForm)